import ClickOutsideDetector from './ClickOutsideDetector';

export default ClickOutsideDetector;
